module.exports = __webpack_public_path__ + "static/img/auth_student_up.d77c0050.png";